
import { Users } from "lucide-react";
import { Event } from "@/types/event";
import { memo } from "react";

interface EventAttendeesProps {
  host: string;
  showGuestList?: boolean;
  attendees?: Array<{
    id: string;
    first_name: string;
    last_name: string;
    quantity: number;
  }>;
}

const EventAttendees = ({
  host,
  showGuestList = false,
  attendees = [],
}: EventAttendeesProps) => {
  return (
    <div className="bg-white rounded-lg p-4 shadow-md mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-semibold">Guest List</h2>
        <Users className="text-gray-400" />
      </div>
      {host && (
        <p className="text-sm text-gray-600 mb-3">
          Hosted by:&nbsp;
          <strong className="capitalize">{host}</strong>
        </p>
      )}
      
      {showGuestList ? (
        <div>
          <p className="text-sm text-gray-600 mb-3">
            Attendees ({attendees.reduce((total, attendee) => total + attendee.quantity, 0)}):
          </p>
          {attendees.length > 0 ? (
            <div className="flex flex-wrap gap-2">
              {attendees.slice(0, 5).map((attendee) => (
                <div key={attendee.id} className="inline-flex items-center bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                  <span className="capitalize">
                    {attendee.first_name}
                    {attendee.quantity > 1 && ` (+${attendee.quantity - 1})`}
                  </span>
                </div>
              ))}
              {attendees.length > 5 && (
                <div className="inline-flex items-center bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                  +{attendees.length - 5}
                </div>
              )}
            </div>
          ) : (
            <p className="text-sm text-gray-500 italic">No attendees yet</p>
          )}
        </div>
      ) : (
        <p className="text-sm text-gray-600">
          Guest list will become available 3 days before the event. Once booked, you can access the private WhatsApp chat with other attendees.
        </p>
      )}
    </div>
  );
};

export default memo(EventAttendees);
